/**
 * Shared utility for managing game history in localStorage.
 * Results are stored as JSON arrays per gameId.
 */

export const saveGameResult = (gameId, result) => {
    try {
        const history = JSON.parse(localStorage.getItem(`history_${gameId}`) || "[]");
        const sessionResult = {
            ...result,
            id: Date.now().toString(36) + Math.random().toString(36).substr(2, 5),
            timestamp: new Date().toISOString()
        };
        history.push(sessionResult);
        // Keep last 1000 results to avoid localStorage bloat
        const limitedHistory = history.slice(-1000);
        localStorage.setItem(`history_${gameId}`, JSON.stringify(limitedHistory));
        return sessionResult;
    } catch (e) {
        console.error("Failed to save game result:", e);
        return null;
    }
};

export const getGameHistory = (gameId) => {
    try {
        return JSON.parse(localStorage.getItem(`history_${gameId}`) || "[]");
    } catch (e) {
        console.error("Failed to get game history:", e);
        return [];
    }
};

export const clearGameHistory = (gameId) => {
    localStorage.removeItem(`history_${gameId}`);
};

/**
 * Converts history to a CSV string for download or display.
 */
export const historyToCSV = (history) => {
    if (history.length === 0) return "";
    
    const headers = Object.keys(history[0]);
    const rows = history.map(item => 
        headers.map(header => {
            const val = item[header];
            return typeof val === 'string' && val.includes(',') ? `"${val}"` : val;
        }).join(',')
    );
    
    return [headers.join(','), ...rows].join('\n');
};
